import { easeExpInOut } from 'd3-ease'

export default {
  duration: 750,
  ease: easeExpInOut,
}
